import { useSummaryDate } from '@renderer/chat/hooks'
import { useSummaryContext } from '../hooks/use-summary-context'
import { useSummaryActions } from '../hooks/use-summary-actions'
import { Button } from '@highlight/ui'

export function ChatAction() {
  const { onStartChat } = useSummaryActions()
  const { summary } = useSummaryContext()
  const { dayLabel } = useSummaryDate(summary)

  return (
    <Button size={'sm'} variant={'outline'} onClick={onStartChat}>
      Chat about {dayLabel}
    </Button>
  )
}
